import { render, staticRenderFns } from "./RegisterCorporation.vue?vue&type=template&id=675a116b&scoped=true&"
import script from "./RegisterCorporation.vue?vue&type=script&lang=js&"
export * from "./RegisterCorporation.vue?vue&type=script&lang=js&"
import style0 from "./RegisterCorporation.vue?vue&type=style&index=0&id=675a116b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675a116b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
